import mapboxgl from 'mapbox-gl';

/**
 * Published path of mapbox-gl's standalone worker, copied verbatim from
 * `node_modules/mapbox-gl/dist` by the `assets` entry in `angular.json` (app#313).
 */
export const MAPBOX_WORKER_PATH = 'mapbox/mapbox-gl-csp-worker.js';

/**
 * Points Mapbox at its standalone worker file instead of the blob worker inlined in the bundle,
 * then keeps the worker pool alive across maps. Call it before every `new mapboxgl.Map`.
 *
 * ⚠ The inlined worker is rebuilt from function SOURCE at runtime. Because the app loads
 * zone.js, the Angular build downlevels mapbox-gl's `async` worker methods into calls to an
 * imported `__async` helper (`nt` when minified) that does not exist inside the worker blob —
 * every map logged `ReferenceError: nt is not defined` in `syncRTLPluginState` (app#313).
 * The asset never passes through esbuild, so its `async` stays native.
 *
 * `prewarm()` keeps the pool alive: without it Mapbox terminates both workers when the last map
 * closes, so every dialog would spawn two new workers and request the ~780 KB file twice — a full
 * download while static files are served `no-store`, a revalidation once app#334 serves them
 * `no-cache` + ETag. `workerUrl` must be set BEFORE `prewarm()`; both calls are idempotent.
 */
export function ensureMapboxWorker(
  lib: Pick<typeof mapboxgl, 'workerUrl' | 'prewarm'> = mapboxgl,
  baseUri: string = document.baseURI
): void {
  lib.workerUrl = new URL(MAPBOX_WORKER_PATH, baseUri).href;
  lib.prewarm();
}
